import React from 'react';
import ENUMS from '../../../enums';
import './notificationItem.scss';

export default function NotificationItem(props) {
  const { notification } = props;
  const [notifData, setNotifData] = React.useState('');
  const [undefNotif, setUndefNotif] = React.useState('');
  React.useEffect(() => {
    if (notification.id && ENUMS.SOCKET_IO_EVENTS.list.filter(e => e.value === notification.type).length > 0) {
      setNotifData(ENUMS.SOCKET_IO_EVENTS.list.filter(e => e.value === notification.type)[0]);
    } else {
      setUndefNotif(notification);
    }
  }, []);

  return (
    <div className="notificationItemContainer">
      <div className="notificationItemTitle">{undefNotif || notifData.title}</div>
      <div className="notificationItemContent">{undefNotif || notifData.content}</div>
      <div className="notificationItemFooter">{notification.createdAt}</div>
    </div>
  );
}
